import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { CodeOutlined, LockOutlined, UserOutlined, LoadingOutlined} from '@ant-design/icons';
// import { Form } from '@ant-design/compatible';
// import '@ant-design/compatible/assets/index.css';
import { Input, Button, Row, Col, Form, message } from 'antd';
import axios from 'axios';
import ENVIRONMENT from '../../../../environments';

class PasswordResetForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      username: props.username,
      code: '',
      password: '',
      password_confirm: '',
      message: '',
      error: '',
      isLoading: '',
      step: 'username',
      // step: 'password_change',
    };
  }

  onSubmit = (values) => {
    if (this.state.step === 'password_change'){
      if(this.state.password === this.state.password_confirm){
        this.props.setPassword(this.state.username, this.state.code, this.state.password)
        .then(() => {
            message.success('Password changed successfully');
            this.setState({
              message: '',
              error: '',
            });
            this.props.history.push('/');
          }
        )
        .catch((err) => this.setState({
          message: '',
          error: err.message,
        }));
      }
      else{
        this.setState({
          message: '',
          error: 'Passwords do not match',
        });
      }
    }
    if (this.state.step === 'verification'){
      this.setState({
        step: 'password_change',
        // message: 'Enter your new Password' 
      });
    }
  }

  validateEmail = (email) => {
    const re = /(?:(?:\r\n)?[ \t])*(?:(?:(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*))*@(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*|(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*)*\<(?:(?:\r\n)?[ \t])*(?:@(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*(?:,@(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*)*:(?:(?:\r\n)?[ \t])*)?(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*))*@(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*\>(?:(?:\r\n)?[ \t])*)|(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*)*:(?:(?:\r\n)?[ \t])*(?:(?:(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*))*@(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*|(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*)*\<(?:(?:\r\n)?[ \t])*(?:@(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*(?:,@(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*)*:(?:(?:\r\n)?[ \t])*)?(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*))*@(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*\>(?:(?:\r\n)?[ \t])*)(?:,\s*(?:(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*))*@(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*|(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*)*\<(?:(?:\r\n)?[ \t])*(?:@(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*(?:,@(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*)*:(?:(?:\r\n)?[ \t])*)?(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*))*@(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*\>(?:(?:\r\n)?[ \t])*))*)?;\s*)/;
    return re.test(String(email).toLowerCase());
}

  validateVerificationCode = (input) => {
    const validations = [

      {
        pattern: '^[^\\s]+(\\s+[^\\s]+)*$', // No leading or trailing spaces
        errorMessage: "Spaces are not allowed, whitespace found at the end.",
      },
    ];

    if (input) {
      for (const validation of validations) {
        console.log(validation);
        const regex = new RegExp(validation.pattern);
        if (!regex.test(input)) {
          return false;
        }
      }
    }

    return true;
  }

  validatePassword = (input) => {
    const validations = [

      {
        pattern: '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$', // No leading or trailing spaces
        errorMessage: "Password should be at least 8 characters including at least one uppercase, one lowercase, one special character and one digit",
      },
    ];

    if (input) {
      for (const validation of validations) {
        console.log(validation);
        const regex = new RegExp(validation.pattern);
        if (!regex.test(input)) {
          return false;
        }
      }
    }

    return true;
  }


  sendVerificationCodeWrapper = () => {
    this.setState({isLoading: true});
    console.log("username" ,this.state.username)
    // check if user entered the email then fetch his username

    if(this.validateEmail(this.state.username)){
      // at this point this.state.username actually contains the email entered by user.
      axios.post(ENVIRONMENT.FETCH_USERNAME, { email: this.state.username })
        .then(res => {
          if(res.data.username){
            this.setState({username: res.data.username})
          }
          this.sendVerificationCode();
      })
  }
  else{
    this.sendVerificationCode();
  }
}

  sendVerificationCode = (values) => {
      this.props.sendVerificationCode(this.state.username)
      .then(() => this.setState({
        message: 'Please check your email for verification code',
        error: '',
        step: 'verification',
      }))
      .catch((err) => {
        this.setState({isLoading: false});
        if (err.code === 'UserNotFoundException') {
          this.setState({ error: 'User not found' });
        } else {
          this.setState({ error: err.message })
        }
      });
  }

  changePassword = (event) => {
    this.setState({ password: event.target.value });
  }

  changePasswordConfirm = (event) => {
    this.setState({ password_confirm: event.target.value });
  }

  changeCode = (event) => {
    this.setState({ code: event.target.value });
  }

  changeUsername = (event) => {
    this.setState({ username: event.target.value });
  }

  render = () => {
    // const { getFieldDecorator } = this.props.form;
    const formDiv = {
      'display': 'flex',
      'justify-content': 'space-around',
      'margin-top': '40px',
    }

    const formStyle = {
      'background-color': 'white',
      'border-radius': '5px'

    }

    return (
      <Row className='justify-on-mobile'>
        <Col span={12} className='hide-on-mobile'>
          <img className="branding-image" src={'/img/introImage.png'} alt="Brand"/>
        </Col>
        <Col xs={22} sm={22} md={24} lg={12} className='web-desktop-width'>
          <div className="login-frm" style={formDiv}>
            <div style={formStyle}>
              <div style={formDiv}>
                <div style={formStyle}>
                 
                  <Form onFinish={this.onSubmit} onFinishFailed={(e) => console.log(e) } className="login-form">
                  {(this.state.step === 'verification') || (this.state.step === 'password_change') ?
                    <h5 className='manrope f-16 w-700 black-00'>Reset password</h5> : ''}
                    <h3 className="manrope f-24 w-700 black-00">
                      {(this.state.step === 'username') ?
                        "Reset your password" : (this.state.step === 'verification') ?
                          "Enter your verification code" : (this.state.step === 'password_change') ? "Enter your new password" : ""}
                    </h3>
                    <p className='manrope f-14 w-500 black-00'>
                    {(this.state.step==='username')?
                      "Enter your username or email below and we’ll send a verification code." : 
                      (this.state.step==='verification')? 
                      "Please check your email for the code and enter it below before continuing to reset your password." :
                     "Enter your new password below and confirm it. Make sure the two passwords match."}
                    </p>
                    
                    {(this.state.step==='username')?
                      <span>
                        <Form.Item
                          name="username"
                          rules={[
                            {
                              required: true,
                              message: <span className='manrope f-14 red'>Please enter your username or email</span>,
                            },{ pattern: "^[^\\s]+(\\s+[^\\s]+)*$", message: <span className='manrope f-14 red'>Spaces are not allowed, whitespace found at the end.</span> },
                          ]}
                        >
                          <Input
                          className='manrope f-14 w-400 placeholder black'
                          placeholder="Username or email"
                            onChange={this.changeUsername}/>
                        </Form.Item>
                        {this.state.error && <div className="manrope f-14 red text-left">{this.state.error} </div>}

                        <Form.Item>
                        <Button disabled={this.state.isLoading || this.state.username == "" || !this.validateVerificationCode(this.state.username)}
                        onClick={() => this.sendVerificationCodeWrapper() }
                          className="modal-okay square font-16 center-btn mt-16">
                          Send code
                          {this.state.isLoading ? <LoadingOutlined spin /> : ''}
                        </Button>
                        </Form.Item>
                        
                      </span>
                    :''
                    }
                    {(this.state.step==='verification')?     
                    <>                    
                        <Form.Item
                          name="Verification Code"
                          rules= {[{ required: true, message:  <span className='manrope f-14 red'>Enter verification code</span> },
                                {pattern: '^[0-9]{1,6}$', message: <span className='manrope f-14 red'>Verification code must consist of 6 digits</span>},
                                {pattern: "^[^\\s]+(\\s+[^\\s]+)*$", message: <span className='manrope f-14 red'>Spaces are not allowed, whitespace found at the end</span>},
                          ]}
                        >
                          <Input
                                  onChange={this.changeCode}
                                  className='manrope f-14 w-400 placeholder black'
                                  placeholder="Verification code"
                              />
                        </Form.Item>
                        {this.state.error && <div className="manrope f-14 red text-left">{this.state.error} </div>}

                      </>
                    :''
                    }
                    {(this.state.step==='password_change')?
                      <span>
                        <Form.Item name='password' rules={[{ required: true, message: <span className='manrope f-14 red'>Please enter your password </span> },
                              {
                                pattern:
                                  "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$",
                                message: <span className='manrope f-14 red'>Password must be 8+ characters with at least 1 uppercase, 1 lowercase, 1 digit, and 1 special character</span>,

                              }]} >
                        
                            <Input
                              className='manrope f-14 w-400 placeholder black'
                              type="password"
                              placeholder="Password"
                              onChange={this.changePassword}
                            />
                        </Form.Item>
                        <Form.Item name='password_confirm' rules={[{ required: true, message: 'Please enter your password again' },
                              {
                                pattern:
                                  "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$",
                                message: <span className='manrope f-14 red'>Password must be 8+ characters with at least 1 uppercase, 1 lowercase, 1 digit, and 1 special character</span>,

                              }]} >
                          
                            <Input
                              className='manrope f-14 w-400 placeholder black'
                              type="password"
                              placeholder="Retype password"
                              onChange={this.changePasswordConfirm}
                            />
                        </Form.Item>
                        {this.state.error && <div className="manrope f-14 red text-left">{this.state.error} </div>}

                    </span>
                    :''
                    }
                     {(this.state.step==='verification' || this.state.step==='password_change')?
                    <Form.Item>
                     
                        <Button htmlType="submit" className="modal-okay square font-16 center-btn mt-16">
                          {(this.state.step==='verification')? 'Continue':'Reset password'}
                        </Button> 
                      
                    </Form.Item>: ''}

                    <Form.Item>
                    <Button className='modal-okay-blue square font-16 center-btn border-none' onClick={() => {
                        window.location.href = "/"
                      }}>
                        Cancel
                      </Button>
                    </Form.Item>
                    
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col md={24} lg={12} className='show-on-mobile mt-40 justify-in-center'>
          <img className="branding-image login-page-mobile-img" src={'/img/introImageMobile.png'} />
        </Col>
      </Row>
    );
  }
}
PasswordResetForm.propTypes = {
  error: PropTypes.string,
  username: PropTypes.string,
  sendVerificationCode: PropTypes.func,
  setPassword: PropTypes.func,
};
export default  withRouter(PasswordResetForm);

